import { render, staticRenderFns } from "./ConfirmDialogWrapper.vue?vue&type=template&id=1efb8a20&scoped=true&"
import script from "./ConfirmDialogWrapper.vue?vue&type=script&lang=js&"
export * from "./ConfirmDialogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDialogWrapper.vue?vue&type=style&index=0&id=1efb8a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb8a20",
  null
  
)

export default component.exports